import * as React from 'react';
import { TOASTER_STATE } from '../../../Model/Enums';
import { useAppDispatch } from '../../../Store/store';
import { useLazyAuthorizeEntrepreneurQuery } from '../../../Store/entrepreneur';
import { useLazyAuthorizeAccountantQuery } from '../../../Store/accountant';
import { changeToasterState } from '../../../Store/layoutSlice';
import { useProgress } from '../../Layout/useProgress';
import { Grecaptcha } from 'reaptcha';
import { SubmitHandler, UseFormRegister } from 'react-hook-form';
import { LoginFormInput } from './LoginForm';

type RegisterFunction = UseFormRegister<LoginFormInput>;

export const useLoginForm = (isAccountant, register: RegisterFunction, reset: () => void) => {
  const [recaptcha, setRecaptcha] = React.useState(null);

  const [authorizeEntrepreneur] = useLazyAuthorizeEntrepreneurQuery();
  const [authorizeAccountant] = useLazyAuthorizeAccountantQuery();
  const { inProgress, setInProgress } = useProgress();

  const recaptchaRef = React.useRef<Grecaptcha>(null);

  const dispatch = useAppDispatch();

  const onSubmit: SubmitHandler<LoginFormInput> = async (data) => {
    setInProgress(true);
    const email = data.email;
    if (recaptcha) {
      try {
        isAccountant
          ? await authorizeAccountant({ email, recaptcha }).unwrap()
          : await authorizeEntrepreneur({ email, recaptcha }).unwrap();
        dispatch(changeToasterState(TOASTER_STATE.ENTREPRENEUR_CREATION_SUCCESS));
        recaptchaRef?.current?.reset();
        reset();
      } catch (e) {
        dispatch(
          changeToasterState(
            isAccountant ? TOASTER_STATE.ACCOUNTANT_AUTH_FAILED : TOASTER_STATE.ENTREPRENEUR_CREATION_FAILED
          )
        );
        recaptchaRef?.current?.reset();
      }
    }
    if (!recaptcha) {
      dispatch(changeToasterState(TOASTER_STATE.RECAPTCHA_WARNING));
    }

    setInProgress(false);
  };

  return { onSubmit, recaptcha, setRecaptcha, recaptchaRef, inProgress };
};
